
import React from 'react';
import { Rate } from 'antd';

const CustomRating = ({ rate, size = 32}) => {

  const rateStyle = {
    width: size,
    height: size
  }

  const customFullStar = <img src="/images/icons/Full star.svg" alt="full-star" style={rateStyle} />;
  const customHalfStar = <img src="/images/icons/Half star.svg" alt="half-star" style={rateStyle} />;
  const customUnfilledStar = <img src="/images/icons/unfilled star.svg" alt="unfilled-star" style={rateStyle} />;

  return (
    
      <Rate
        disabled
        allowHalf
        defaultValue={rate}
        character={({ index }) => {
          if (rate >= index + 1) {
            return customFullStar;
          } else if (rate > index && rate < index + 1) {
            return customHalfStar;
          } else {
            return customUnfilledStar;
          }
        }}
      />
  );
};

export default CustomRating;
